import { render, staticRenderFns } from "./textArea.vue?vue&type=template&id=12b1b7d8"
import script from "./textArea.vue?vue&type=script&lang=js"
export * from "./textArea.vue?vue&type=script&lang=js"
import style0 from "./textArea.vue?vue&type=style&index=0&id=12b1b7d8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports